import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import ArrowBack from '@mui/icons-material/ArrowBack'
import { useTranslation } from 'react-i18next'
import { getButtonTestId } from '../Buttons/getButtonTestId'

/** @notExported */
interface BackButtonProps {
  /** Action to perform when button is clicked. */
  clickAction?: () => void
  /** Test id of the button. */
  testId?: string
}

/**
 * Back button component.
 *
 * @returns Back button component.
 * @notExported
 * @category Buttons
 */
const BackButton: React.FC<BackButtonProps> = ({ clickAction, testId }) => {
  const { t } = useTranslation()
  const label = t('back') as string
  const resolvedTestId = getButtonTestId({ fallback: 'button-back', label, testId })
  return (
    <Tooltip title={label} describeChild>
      <IconButton
        aria-label={label}
        data-testid={resolvedTestId}
        onClick={() => clickAction && clickAction()}
        size="large"
      >
        <ArrowBack />
      </IconButton>
    </Tooltip>
  )
}

export default BackButton
